import { PayCodeMeasureUnit } from "@/data/pay-codes";

export const formatLoggedTime = (amount: number, measureUnit: PayCodeMeasureUnit): string => {
  if (measureUnit === "DAILY") {
    return `${amount}d`;
  }

  const hours = Math.floor(amount / 60);
  const minutes = amount - hours * 60;
  const toFormat = [];

  if (amount === 0) {
    toFormat.push("0h");
  }

  if (hours > 0) {
    toFormat.push(`${hours}h`);
  }

  if (minutes > 0) {
    toFormat.push(`${minutes}m`);
  }

  return toFormat.join(" ");
};
